/* One motion rhythm; success feedback only follows a confirmed Shopify cart add. */
(() => {
  if(window.JoffzHarmony)return;
  const strings=JSON.parse(document.querySelector('[data-harmony-config]')?.textContent||'{}');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  window.JoffzHarmony={strings};
  const ease='cubic-bezier(.22,1,.36,1)';
  const animate=(element,frames,duration=300)=>{if(element&&!reduced.matches)element.animate(frames,{duration,easing:ease});};
  const seen=new WeakSet();
  const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    entry.target.classList.remove('j-harmony-pending');
    animate(entry.target,[{opacity:.65,transform:'translateY(12px)'},{opacity:1,transform:'none'}],500);
    reveal.unobserve(entry.target);
  }),{rootMargin:'70px 0px',threshold:.02});
  const storySizes=new Map();
  const sizeStories=()=>{
    for(const [card,observer] of storySizes){if(!card.isConnected){observer.disconnect();storySizes.delete(card);}}
    document.querySelectorAll('[data-brand-story]').forEach(card=>{
      if(storySizes.has(card))return;
      const item=card.closest('.joffz-insert-card,.joffz-carousel__slide--story,.jse__item--story')||card;
      const neighbour=[item.previousElementSibling,item.nextElementSibling].find(node=>node&&!node.matches('[data-brand-story],.joffz-insert-card,.joffz-carousel__slide--story,.jse__item--story'));
      const media=neighbour?.querySelector('.joffz-home-frame-card,.card--product');
      if(!media)return;
      const update=()=>{const height=media.getBoundingClientRect().height;if(height>0)card.style.setProperty('--jmark-media-height',height+'px');};
      const observer=new ResizeObserver(update);observer.observe(media);storySizes.set(card,observer);update();
    });
  };
  const init=()=>{
    sizeStories();
    document.querySelectorAll('[data-harmony-reveal]').forEach(element=>{
      if(seen.has(element))return;seen.add(element);
      if(reduced.matches||element.getBoundingClientRect().top<innerHeight)return;
      element.classList.add('j-harmony-pending');reveal.observe(element);
    });
    document.querySelectorAll('[data-studio-edit]').forEach(section=>{
      if(section.dataset.motionReady)return;section.dataset.motionReady='true';
      const track=section.querySelector('[data-studio-track]');
      if(!track)return;
      const prev=section.querySelector('[data-studio-prev]'),next=section.querySelector('[data-studio-next]');
      const update=()=>{if(prev)prev.disabled=track.scrollLeft<3;if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
      const move=direction=>track.scrollBy({left:direction*((track.firstElementChild?.getBoundingClientRect().width||250)+16),behavior:reduced.matches?'instant':'smooth'});
      prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event=>{if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();move(event.key==='ArrowRight'?1:-1);});
      const resize=new ResizeObserver(update);resize.observe(track);update();
      section.addEventListener('shopify:section:unload',()=>resize.disconnect(),{once:true});
    });
  };
  const tick=()=>{
    const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');
    const path=document.createElementNS(icon.namespaceURI,'path');path.setAttribute('d','m5 12 4 4L19 6');icon.append(path);return icon;
  };
  let toast,timer;
  const feedback=message=>{
    toast ||= Object.assign(document.createElement('div'),{className:'joffz-cart-feedback'});
    toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');toast.replaceChildren(tick(),document.createTextNode(message));
    if(!toast.isConnected)document.body.append(toast);
    toast.hidden=false;animate(toast,[{opacity:0,transform:'translateY(9px)'},{opacity:1,transform:'none'}]);
    clearTimeout(timer);timer=setTimeout(()=>toast.hidden=true,3400);
  };
  document.addEventListener('variant:add',event=>{
    const form=event.detail?.formElement;
    const button=form?.querySelector('[name="add"]');
    const label=button?.querySelector('[data-atc-label]');
    const title=form?.closest('joffz-pdp2')?.querySelector('h1')?.textContent.trim();
    feedback((strings.added||'Added to your cart')+(title?' · '+title:''));
    if(!button||!label)return;
    const original=label.textContent;
    label.replaceChildren(tick(),document.createTextNode(strings.added||'Added to your cart'));button.classList.add('j-harmony-added');
    animate(button,[{transform:'scale(1)'},{transform:'scale(1.018)'},{transform:'scale(1)'}],360);
    setTimeout(()=>{button.classList.remove('j-harmony-added');if(label.textContent===(strings.added||'Added to your cart'))label.textContent=original;},2000);
  });
  document.addEventListener('variant:change',event=>{
    const pdp=event.target.closest?.('joffz-pdp2');if(!pdp)return;
    animate(pdp.querySelector('.jp2-art'),[{opacity:.7,transform:'scale(.987)'},{opacity:1,transform:'scale(1)'}],320);
    animate(pdp.querySelector('[data-price]'),[{opacity:.5},{opacity:1}],220);
    pdp.querySelectorAll('[data-option-value]').forEach(element=>animate(element,[{opacity:.55},{opacity:1}],220));
  });
  document.addEventListener('cart:change',event=>{
    const count=document.querySelector('#cart-icon-bubble .cart-count-bubble');
    const quantity=Number(event.detail?.cart?.item_count);
    if(count&&Number.isFinite(quantity)){
      count.classList.toggle('hidden',quantity===0);count.classList.toggle('show-count',quantity>0);
      const label=count.querySelector('[aria-hidden="true"]');if(label)label.textContent=String(quantity);
    }
    animate(count,[{transform:'scale(1)'},{transform:'scale(1.2)'},{transform:'scale(1)'}],380);
  });
  document.addEventListener('shopify:section:load',init);
  const grid=document.querySelector('#ProductGridContainer');
  if(grid)new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&(node.matches('[data-brand-story]')||node.querySelector('[data-brand-story]')))))sizeStories();}).observe(grid,{childList:true,subtree:true});
  window.addEventListener('pageshow',()=>document.querySelectorAll('.j-harmony-pending').forEach(e=>e.classList.remove('j-harmony-pending')));
  reduced.addEventListener('change',()=>{if(reduced.matches)document.querySelectorAll('.j-harmony-pending').forEach(e=>e.classList.remove('j-harmony-pending'));});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
